/**
 * JWT 解析工具模块，提供 exp 等声明的解析能力。
 */

/**
 * 解析 JWT 中的 exp 声明，单位为秒。
 * @param {string} token 待解析的 JWT 字符串
 * @returns {number|null} exp 时间戳（秒），解析失败返回 null
 */
export const getJwtExp = (token) => {
	if (typeof token !== "string" || token.length === 0) {
		return null;
	}

	const segments = token.split(".");
	if (segments.length < 2) {
		return null;
	}

	try {
		const payloadSegment = segments[1].replace(/-/g, "+").replace(/_/g, "/");
		const decodedPayload = decodeBase64(payloadSegment);
		const payload = JSON.parse(decodedPayload);
		return typeof payload.exp === "number" ? payload.exp : null;
	} catch {
		return null;
	}
};

/**
 * 解码 Base64（URL 安全）字符串。
 *
 * 本应用只跑在浏览器里，`atob` 一定可用；
 * 早期为兼容 Node 而保留的 Buffer 分支会引入 `Buffer` 未定义的类型错误，已移除。
 * @param {string} value Base64 字符串
 * @returns {string} 解码后的字符串
 */
const decodeBase64 = (value) => globalThis.atob(value);
